/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	(function ready() {
	
		var _polyfills = __webpack_require__(1);
		var _extendStandartPrototypes = __webpack_require__(2);
		var CustomSelect = __webpack_require__(3);
		var SimpleMenu = __webpack_require__(6);
		var SimpleVerticalSlider = __webpack_require__(7);
		var SliderWithControlls = __webpack_require__(8);
		var LangSwitcher = __webpack_require__(12);
		var Popup = __webpack_require__(13);
		var ContactFormController = __webpack_require__(14);
	
		_polyfills.init();
		_extendStandartPrototypes.init();
	
		var headerElem = document.querySelector('#header');
		if (headerElem) {
			var header = new SimpleMenu({
				elem: headerElem,
				openBtn: document.querySelector('#header_menu_open_btn'),
				closeBtn: document.querySelector('#header_menu_close_btn')
			});
		}
	
		var langSelectElemsArr = [];
	
		var langSelectHeaderElem = document.querySelector('#lang_switch_header');
		if (langSelectHeaderElem) {
			var langSelectHeader = new CustomSelect({
				elem: langSelectHeaderElem
			});
	
			langSelectElemsArr.push(langSelectHeaderElem);
		}
	
		var langSelectFooterElem = document.querySelector('#lang_switch_footer');
		if (langSelectFooterElem) {
			var langSelectFooter = new CustomSelect({
				elem: langSelectFooterElem
			});
	
			langSelectElemsArr.push(langSelectFooterElem);
		}
	
		var langSwitcher = new LangSwitcher({
			langSelectElemsArr: langSelectElemsArr
		});
	
		var productSliderElem = document.querySelector('#product_vertical_slider');
		if (productSliderElem) {
			 var customMoveCheck = function(self, slideIndex, slidesArr, mainElem) {
				if (mainElem.classList.contains('text_slider_transition')) {
					return false;
				}
				return true;
			};
	
			var imageSlider = new SimpleVerticalSlider({
				elem: productSliderElem,
				transitionDuration: 0.5,
				overflowHiddenContainerSelector: '.image_overflow_hidden_container',
				overflowContainerSelector: '.image_overflow_block',
				slideSelector: '.image_slide',
				transitionTopWidthArr: ['md', 'lg'],
				transitionOpacityWidthArr: ['sm'],
				transitionInProcessClass: 'image_slider_transition',
				controllsSelector: '',
				customMoveCheck: customMoveCheck
			});
	
			var textSlider = new SimpleVerticalSlider({
				elem: productSliderElem,
				transitionDuration: 0.5,
				overflowHiddenContainerSelector: '.text_overflow_hidden_container',
				overflowContainerSelector: '.text_overflow_block',
				slideSelector: '.text_slide',
				transitionTopWidthArr: [],
				transitionOpacityWidthArr: ['sm', 'md', 'lg'],
				transitionInProcessClass: 'text_slider_transition',
				controllsSelector: '',
				customMoveCheck: customMoveCheck
			});
		}
	
		var feedbackSliderElem = document.querySelector('#feedback_slider');
		if (feedbackSliderElem) {
			var feedbackSlider = new SliderWithControlls({
				elem: feedbackSliderElem,
				delay: 5000,
				breakPoint: 0,
				controllsSelector: '#page_slide5_slider_controlls'
			});
		}
	
		var registrationFormPopupElem = document.querySelector('#registration_form_popup');
		if (registrationFormPopupElem) {
			var registrationFormPopup = new Popup({
				elem: registrationFormPopupElem,
				popupOpenBtnSelector: '[data-popup-action="open"]',
				popupCloseBtnSelector: '[data-popup-action="close"]'
			});
		}
	
		var thanksFormPopupElem = document.querySelector('#thanks_popup');
		if (thanksFormPopupElem) {
			var thanksFormPopup = new Popup({
				elem: thanksFormPopupElem,
				popupOpenBtnSelector: '[data-popup-action="open"]',
				popupCloseBtnSelector: '[data-popup-action="close"]'
			});
		}
	
		var registrationFormElem = document.querySelector('#registration_from');
		if (registrationFormElem) {
			var registrationForm = new ContactFormController({
				elem: registrationFormElem,
				actionUrl: registrationFormElem.action,
				method: registrationFormElem.method,
				callback: function(self) {
					self._sendCustomEvent(document, 'closePopup', { bubbles: true, detail: { targetPopupElem: registrationFormPopupElem } });
					if (thanksFormPopup) {
						self._sendCustomEvent(document, 'openPopup', { bubbles: true, detail: { targetPopupElem: thanksFormPopupElem } });
					}
				}
			});
		}
	
	})();


/***/ }),
/* 1 */
/***/ (function(module, exports) {

	"use strict";
	
	var _polyfills = {
		init: function() {
			// console.log('running runAll');
			for (var key in this) {
				// console.log(key);
				if (/\bpolyfillFor/.test(key)) {
					this[key]();
				}
			}
		},
	
		polyfillForMatches: function() {
			// console.log('running polyfillForMatches');
			var e = Element.prototype;
			e.matches || (e.matches=e.matchesSelector||function(selector) {
					var matches = document.querySelectorAll(selector), th = this;
					return Array.prototype.some.call(matches, function(e) {
						return e === th;
					});
				});
		},
	
		polyfillForClosest: function() {
			// console.log('running polyfillForClosest');
			var e = Element.prototype;
			e.closest = e.closest || function(css) {
					var node = this;
	
					while (node) {
						if (node.matches(css)) return node;
						else node = node.parentElement;
					}
					return null;
				}
		},
	
		polyfillForCustomEvent: function () {
			// console.log('running polyfillForCustomEvent');
			if ( typeof window.CustomEvent === "function" ) return false;
	
			function CustomEvent ( event, params ) {
				params = params || { bubbles: false, cancelable: false, detail: undefined };
				var evt = document.createEvent( 'CustomEvent' );
				evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
				return evt;
			}
	
			CustomEvent.prototype = window.Event.prototype;
	
			window.CustomEvent = CustomEvent;
		},
	
		polyfillForInsertAdjacent: function() {
			// console.log('running polyfillForCustomEvent');
			if (typeof HTMLElement != "undefined" && !HTMLElement.prototype.insertAdjacentElement) {
				HTMLElement.prototype.insertAdjacentElement = function(where, parsedNode) {
					switch (where) {
						case 'beforeBegin':
							this.parentNode.insertBefore(parsedNode, this);
							break;
						case 'afterBegin':
							this.insertBefore(parsedNode, this.firstChild);
							break;
						case 'beforeEnd':
							this.appendChild(parsedNode);
							break;
						case 'afterEnd':
							if (this.nextSibling) this.parentNode.insertBefore(parsedNode, this.nextSibling);
							else this.parentNode.appendChild(parsedNode);
							break;
					}
				};
	
				HTMLElement.prototype.insertAdjacentHTML = function(where, htmlStr) {
					var r = this.ownerDocument.createRange();
					r.setStartBefore(this);
					var parsedHTML = r.createContextualFragment(htmlStr);
					this.insertAdjacentElement(where, parsedHTML)
				};
	
	
				HTMLElement.prototype.insertAdjacentText = function(where, txtStr) {
					var parsedText = document.createTextNode(txtStr)
					this.insertAdjacentElement(where, parsedText)
				};
			}
		},
	
		polyfillForRequestAnimationFrame: function() {
			var lastTime = 0;
			var vendors = ['ms', 'moz', 'webkit', 'o'];
			for(var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
				window.requestAnimationFrame = window[vendors[x]+'RequestAnimationFrame'];
				window.cancelAnimationFrame = window[vendors[x]+'CancelAnimationFrame']
										   || window[vendors[x]+'CancelRequestAnimationFrame'];
			}
	
			if (!window.requestAnimationFrame)
				window.requestAnimationFrame = function(callback, element) {
					var currTime = new Date().getTime();
					var timeToCall = Math.max(0, 16 - (currTime - lastTime));
					var id = window.setTimeout(function() { callback(currTime + timeToCall); },
					  timeToCall);
					lastTime = currTime + timeToCall;
					return id;
				};
	
			if (!window.cancelAnimationFrame)
				window.cancelAnimationFrame = function(id) {
					clearTimeout(id);
				};
	
		},
	
		polyfillForTemplate: function() {
			if('content' in document.createElement('template')) {
				return false;
			}
	
			var qPlates = document.getElementsByTagName('template'),
				plateLen = qPlates.length,
				elPlate,
				qContent,
				contentLen,
				docContent;
	
			for(var x=0; x<plateLen; ++x) {
				elPlate = qPlates[x];
				qContent = elPlate.childNodes;
				contentLen = qContent.length;
				docContent = document.createDocumentFragment();
	
				while(qContent[0]) {
					docContent.appendChild(qContent[0]);
				}
	
				elPlate.content = docContent;
			}
		},
	
		polyfillForReportValidity: function() {
			if (!HTMLFormElement.prototype.reportValidity) {
				HTMLFormElement.prototype.reportValidity = function() {
					if (this.checkValidity()) return true;
					var btn = document.createElement('button');
					this.appendChild(btn);
					btn.click();
					this.removeChild(btn);
					return false;
				}
			}
		}
	};
	
	try {
		module.exports = _polyfills;
	} catch (err) {
		console.warn(err);
	}


/***/ }),
/* 2 */
/***/ (function(module, exports) {

	"use strict";
	
	var _extendStandartPrototypes = {
		init: function() {
			// console.log('running runAll');
			for (var key in this) {
				// console.log(key);
				if (/\bexpandFor/.test(key)) {
					this[key]();
				}
			}
		},
	
		expandForStringCapitalize: function() {
			// console.log('running polyfillForMatches');
			String.prototype.capitalize = function(lower) {
				return (lower ? this.toLowerCase() : this).replace(/(?:^|\s)\S/g, function(a) { return a.toUpperCase(); });
			};
		},
	};
	
	try {
		module.exports = _extendStandartPrototypes;
	} catch (err) {
		console.warn(err);
	}


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	try {
		var Helper = __webpack_require__(4);
	} catch (err) {
		console.warn(err);
	}
	
	function CustomSelect(options) {
		options.name = options.name || 'CustomSelect';
		Helper.call(this, options);
	
		this._elem = options.elem;
		this._titleElem = this._elem.querySelector('.title');
		this._listElem = this._elem.querySelector('.option_list');
		this._defaultText = this._titleElem.innerHTML;
		this._required = this._elem.classList.contains('required');
		this._isOpen = false;
	
		this._onClick = this._onClick.bind(this);
		this._onDocumentClick = this._onDocumentClick.bind(this);
		this._onResize = this._onResize.bind(this);
	
		this._init();
	}
	
	CustomSelect.prototype = Object.create(Helper.prototype);
	CustomSelect.prototype.constructor = CustomSelect;
	
	CustomSelect.prototype._init = function() {
		this._elem.dataset.value = '';
	
		this._revealPublicMethods();
		this._setDefaultBySelectedAttr();
	
		this._addListener(this._elem, 'click', this._onClick);
	};
	
	CustomSelect.prototype._onResize = function() {
		this._listElem.style.maxHeight = window.innerHeight - this._listElem.getBoundingClientRect().top + 'px';
	};
	
	CustomSelect.prototype._onClick = function(event) {
		event.preventDefault();
	
		if (event.target === this._titleElem) {
			this._toggle();
		} else if (event.target.classList.contains('option')) {
			this._setValue(event.target.textContent, event.target.dataset.value);
			this._elem.classList.add('option_selected');
			this._close();
		}
	};
	
	CustomSelect.prototype._onDocumentClick = function(event) {
		if (!this._elem.contains(event.target)) this._close();
	};
	
	CustomSelect.prototype._setValue = function(title, value) {
		this._titleElem.innerHTML = title;
		this._elem.dataset.value = title;
		this._value = value;
	
		this._sendCustomEvent(this._elem, 'customselect', {
			bubbles: true,
			detail: {
				title: title,
				value: value
			}
		});
	};
	
	CustomSelect.prototype.getElem = function() {
		return this._elem;
	};
	
	CustomSelect.prototype._toggle = function() {
		if (this._isOpen) {
			this._removeListener(window, 'resize', this._onResize);
			this._close();
		} else {
			this._open();
			this._onResize();
			this._addListener(window, 'resize', this._onResize);
		}
	};
	
	CustomSelect.prototype._open = function() {
		this._elem.classList.add('open');
		this._addListener(document, 'click', this._onDocumentClick);
		this._isOpen = true;
		this._sendCustomEvent(this._elem, 'customselectopenclose', {
			bubbles: true,
			detail: {
				open: true
			}
		});
	};
	
	CustomSelect.prototype._close = function() {
		this._elem.classList.remove('open');
		this._removeListener(document, 'click', this._onDocumentClick);
		this._isOpen = false;
		this._sendCustomEvent(this._elem, 'customselectopenclose', {
			bubbles: true,
			detail: {
				open: false
			}
		});
	};
	
	CustomSelect.prototype._getOptionElems = function() {
		return this._elem.querySelectorAll('.option');
	};
	
	CustomSelect.prototype.setOption = function(option) {
		if (!option) return;
	
		var optionSetSuccess = false;
	
		if (option.index !== undefined && typeof option.index === 'number') {
			optionSetSuccess = this._setOptionByIndex(option.index);
	
		} else if (option.value) {
			optionSetSuccess = this._setOptionByValue(option.value);
		}
	
		if (optionSetSuccess) {
			this._sendCustomEvent(this._titleElem, 'focus', {bubbles: true});
			this._sendCustomEvent(this._titleElem, 'blur', {bubbles: true});
		}
	
		return optionSetSuccess;
	};
	
	CustomSelect.prototype._setOptionByIndex = function(optionIndex) {
		var optionElemArr = this._getOptionElems();
	
		optionIndex = parseInt(optionIndex);
	
		if (optionElemArr[optionIndex]) {
			var option = optionElemArr[optionIndex];
	
			this._setValue(option.textContent, option.dataset.value);
			this._elem.classList.add('option_selected');
	
			return true;
		} else {
			// this.resetToDefault();
			return false;
		}
	};
	
	CustomSelect.prototype._setOptionByValue = function(optionValue) {
		var optionElemArr = this._getOptionElems();
	
		for (var i = 0; i < optionElemArr.length; i++) {
			if (optionElemArr[i].dataset.value === optionValue) {
				var option = optionElemArr[i];
	
				this._setValue(option.textContent, option.dataset.value);
				this._elem.classList.add('option_selected');
	
				return true;
			}
		}
	
		// this.resetToDefault();
		return false;
	};
	
	CustomSelect.prototype._revealPublicMethods = function() {
		this._elem.setOption = this.setOption.bind(this);
		this._elem.resetToDefault = this.resetToDefault.bind(this);
	};
	
	CustomSelect.prototype.resetToDefault = function() {
		this._elem.classList.remove('option_selected');
		this._titleElem.innerHTML = this._defaultText;
		this._elem.dataset.value = '';
	
		this._sendCustomEvent(this._titleElem, 'focus', {bubbles: true});
		this._sendCustomEvent(this._titleElem, 'blur', {bubbles: true});
	};
	
	CustomSelect.prototype.hideByDependency = function() {
		// this._elem.style.display = 'none';
		this._elem.classList.remove('required');
		this._elem.classList.remove('error');
		this._elem.classList.remove('reveal_by_dependency');
		this._elem.classList.add('hide_by_dependency');
		this.resetToDefault();
	};
	
	CustomSelect.prototype.revealByDependency = function() {
		// this._elem.style.display = '';
		this._elem.classList.remove('hide_by_dependency');
		this._elem.classList.add('reveal_by_dependency');
		if (this._required) {
			this._elem.classList.add('required');
		}
	};
	
	CustomSelect.prototype._setDefaultBySelectedAttr = function() {
		var optionElemArr = this._getOptionElems();
	
		for (var i = 0; i < optionElemArr.length; i++) {
			if (optionElemArr[i].getAttribute('data-selected') !== null) {
				var option = optionElemArr[i];
	
				this._setValue(option.textContent, option.dataset.value);
				this._elem.classList.add('option_selected');
	
				return;
			}
		}
	};
	
	try {
		module.exports = CustomSelect;
	} catch (err) {
		console.warn(err);
	}


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var id = 0;
	
	function Helper(options) {
		this.NAME = (options.name || 'Helper') + (options.noId ? '' : this._createUniqId());
		this._listenerArr = [];
		/*this._errorNotificationHTML = '<div class="error_notification">' +
			'<p>An Error Occurred!</p>' +
			'<p>Please Try Again Later.</p>' +
			'<button>ОК</button>' +
			'</div>';*/
	
		/*this._closeErrorNotification = this._closeErrorNotification.bind(this);*/
	}
	
	Helper.prototype._createUniqId = function() {
		var idString = '<#' + id.toString(16) + '>';
		id++;
		return idString;
	};
	
	Helper.prototype._addListener = function(element, event, handler, phase) {
		if (!phase) {
			phase = false;
		}
	
		this._listenerArr.push({
			elem: element,
			event: event,
			handler: handler,
			phase: phase
		});
		var index = this._listenerArr.length - 1;
	
		this._listenerArr[index].elem.addEventListener(
			this._listenerArr[index].event,
			this._listenerArr[index].handler,
			this._listenerArr[index].phase
		);
	};
	
	Helper.prototype._removeListener = function(element, event, handler, phase) {
		if (!phase) {
			phase = false;
		}
	
		var index = this._returnListenerIndexInArr(element, event, handler, phase);
	
		if (index >= 0) {
			this._listenerArr[index].elem.removeEventListener(
				this._listenerArr[index].event,
				this._listenerArr[index].handler,
				this._listenerArr[index].phase
			);
			this._listenerArr.splice(index, 1);
		} else {
			// console.log(this.NAME + ': Listener was not found in array!');
		}
	};
	
	Helper.prototype._returnListenerIndexInArr = function(element, event, handler, phase) {
		for (var i = this._listenerArr.length - 1; i >= 0; i--) {
			if (this._listenerArr[i].elem === element &&
				this._listenerArr[i].event === event &&
				this._listenerArr[i].handler === handler &&
				this._listenerArr[i].phase === phase) {
				return i;
			}
		}
	
		return -1;
	};
	
	Helper.prototype.remove = function() {
		//removing listeners
		for (var i = this._listenerArr.length - 1; i >= 0; i--) {
			this._removeListener(this._listenerArr[i].elem, this._listenerArr[i].event, this._listenerArr[i].handler);
		}
	
		//removing obj properties
		for (var key in this) {
			if (this.hasOwnProperty(key)) {
				if (typeof this[key] === 'object' && this[key].remove && this[key].remove !== document.documentElement.remove) {
					this[key].remove();
				}
	
				delete this[key];
			}
		}
	
		this.__proto__ = {};
	};
	
	Helper.prototype._showErrorNotification = function() {
		/*this._cover = document.createElement('div');
		this._cover.style.cssText = 'z-index: 1000; position: fixed; height: 100%; width: 100%; top: 0; left: 0; background: rgba(255, 255, 255, 0.25)';
		this._cover.innerHTML = this._errorNotificationHTML;
	
		document.body.insertAdjacentElement('afterBegin', this._cover);
		document.body.style.overflow = 'hidden';
		this._addListener(document.body, 'click', this._closeErrorNotification);*/
	
		new ModalWindow({
			modalClass: 'error_notification',
			modalInnerHTML: '<p>An Error Occurred!</p>' +
			'<p>Please Try Again Later.</p>'
		});
	};
	
	/*Helper.prototype._closeErrorNotification = function(e) {
		var target = e.target;
		if (target.tagName !== 'BUTTON') return;
	
		document.body.removeChild(this._cover);
		delete this._cover;
		document.body.style.overflow = '';
		this._removeListener(document.body, 'click', this._closeErrorNotification);
	};*/
	
	Helper.prototype._sendCustomEvent = function(elem, eventName, options) {
		var widgetEvent = new CustomEvent(eventName, options);
		elem.dispatchEvent(widgetEvent);
	};
	
	Helper.prototype._loadImages = function(imgSrcArr) {
		if (!imgSrcArr) return;
	
		if (typeof imgSrcArr === 'string') {
			imgSrcArr = [imgSrcArr];
		}
	
		this._preloadedImages = [];
	
		for (var i = 0; i < imgSrcArr.length; i++) {
			this._preloadedImages[i] = new Image();
			this._preloadedImages[i].src = imgSrcArr[i];
		}
	};
	
	Helper.prototype._checkScreenWidth = function(min, max) {
		var windowWidth = window.innerWidth;
	
		if ((min !== undefined && min !== false) || (max !== undefined && max !== false)) {
			if (min === undefined || min === false) {
				min = 0;
			}
			if (max === undefined || max === false) {
				max = windowWidth;
			}
	
			return min <= windowWidth && windowWidth <= max;
	
		} else {
			var width = null;
	
			if (windowWidth >= 1200) {
				width = 'lg';
			} else if (windowWidth >= 992 && windowWidth < 1200) {
				width = 'md';
			} else if (windowWidth >= 768 && windowWidth < 992) {
				width = 'sm';
			} else if (windowWidth < 768) {
				width = 'xs';
			}
	
			return width;
		}
	};
	
	Helper.prototype._setVendorCss = function(elem, prop, value) {
		var propCap = prop.capitalize();
		elem.style["Webkit" + propCap] = value;
		elem.style["webkit" + propCap] = value;
		elem.style["-webkit-" + prop] = value;
		elem.style["Moz" + propCap] = value;
		elem.style["moz" + propCap] = value;
		elem.style["-moz-" + prop] = value;
		elem.style["ms" + propCap] = value;
		elem.style["-ms-" + prop] = value;
		elem.style["O" + propCap] = value;
		elem.style["o" + propCap] = value;
		elem.style["-o-" + prop] = value;
		elem.style[prop] = value;
	};
	
	Helper.prototype._getCookie = function(sKey) {
		if (!sKey) { return null; }
		return decodeURIComponent(document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*" + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1")) || null;
	};
	
	try {
		module.exports = Helper;
	} catch (err) {
		console.warn(err);
	}
	
	try {
		var ModalWindow = __webpack_require__(5);
	} catch (err) {
		console.warn(err);
	}
	


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	try {
		var Helper = __webpack_require__(4);
	} catch (err) {
		console.warn(err);
	}
	
	function ModalWindow(options) {
		options.name = options.name || 'ModalWindow';
		Helper.call(this, options);
	
		this._windowOuterHTML = this._createModalHTML(options.modalClass, options.modalInnerHTML, options.buttons);
		this._callback = options.callback;
	
		this._closeModalWindow = this._closeModalWindow.bind(this);
		this._showModalWindow();
	}
	
	ModalWindow.prototype = Object.create(Helper.prototype);
	ModalWindow.prototype.constructor = ModalWindow;
	
	ModalWindow.prototype._createModalHTML = function(modalClass, modalInnerHTML, buttons) {
		var buttonsHTML = '';
	
		for (var key in buttons) {
			buttonsHTML += '<button class="btn ' + key + '-btn" data-action="' + key + '">' + buttons[key] + '</button>';
		}
	
		if (!buttonsHTML) {
			buttonsHTML = '<button class="btn ok-btn" data-action="ok">ОК</button>';
		}
	
		return '<div class="' + modalClass + '">' +
			modalInnerHTML +
			buttonsHTML +
			'</div>';
	};
	
	ModalWindow.prototype._showModalWindow = function() {
		this._cover = document.createElement('div');
		this._cover.style.cssText = 'z-index: 1000; position: fixed; height: 100%; width: 100%; top: 0; left: 0; background: rgba(255, 255, 255, 0.25)';
		this._cover.innerHTML = this._windowOuterHTML;
	
		document.body.insertAdjacentElement('afterBegin', this._cover);
		document.body.style.overflow = 'hidden';
		this._addListener(this._cover, 'click', this._closeModalWindow);
	};
	
	ModalWindow.prototype._closeModalWindow = function(e) {
		var target = e.target;
		var button = target.closest('button');
		if (target.tagName !== 'BUTTON' || !target.dataset.action) return;
	
		var userAction = target.dataset.action;
	
		this._sendCustomEvent(document, 'modalAction', {
			bubbles: true,
			detail: {
				action: userAction
			}
		});
	
		document.body.removeChild(this._cover);
		delete this._cover;
		document.body.style.overflow = '';
		this._removeListener(this._cover, 'click', this._closeModalWindow);
	
		if (this._callback) {
			this._callback(userAction);
		}
	
		this.remove();
	};
	
	try {
		module.exports = ModalWindow;
	} catch (err) {
		console.warn(err);
	}


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	try {
		var Helper = __webpack_require__(4);
	} catch (err) {
		console.warn(err);
	}
	
	function SimpleMenu(options) {
		options.name = options.name || 'SimpleMenu';
		Helper.call(this, options);
	
		this._elem = options.elem;
		this._openBtn = options.openBtn;
		this._closeBtn = options.closeBtn;
		this._menuOpenClass = options.menuOpenClass || 'menu_open';
		this._pageScrolledClass = options.pageScrolledClass || 'page_scrolled_down';
	
		this._onOpenBtnClick = this._onOpenBtnClick.bind(this);
		this._onCloseBtnClick = this._onCloseBtnClick.bind(this);
		this._onWindowScroll = this._onWindowScroll.bind(this);
	
		this._init();
	}
	
	SimpleMenu.prototype = Object.create(Helper.prototype);
	SimpleMenu.prototype.constructor = SimpleMenu;
	
	SimpleMenu.prototype._init = function() {
		this._onWindowScroll();
	
		this._addListener(this._openBtn, 'click', this._onOpenBtnClick);
		this._addListener(this._closeBtn, 'click', this._onCloseBtnClick);
		this._addListener(window, 'scroll', this._onWindowScroll);
	};
	
	SimpleMenu.prototype._onOpenBtnClick = function() {
		this._elem.classList.add(this._menuOpenClass);
	};
	
	SimpleMenu.prototype._onCloseBtnClick = function() {
		this._elem.classList.remove(this._menuOpenClass);
	};
	
	SimpleMenu.prototype._onWindowScroll = function() {
		var currentScroll = window.scrollY || document.documentElement.scrollTop;
	
		if (currentScroll > 0 && !this._headerClassSet) {
			this._headerClassSet = true;
			this._elem.classList.add(this._pageScrolledClass);
	
		} else if (currentScroll === 0 && this._headerClassSet) {
			this._headerClassSet = false;
			this._elem.classList.remove(this._pageScrolledClass);
	
		}
	};
	
	try {
		module.exports = SimpleMenu;
	} catch (err) {
		console.warn(err);
	}


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	try {
		var Helper = __webpack_require__(4);
	} catch (err) {
		console.warn(err);
	}
	
	function SimpleVerticalSlider(options) {
		options.name = options.name || 'SimpleVerticalSlider';
		Helper.call(this, options);
	
		this._elem = options.elem;
		this._transitionDuration = options.transitionDuration || 0.5;
		this._overflowHiddenContainerSelector = options.overflowHiddenContainerSelector || '.overflow_hidden_container';
		this._overflowContainerSelector = options.overflowContainerSelector || '.overflow_block';
		this._controllsSelector = options.controllsSelector || '';
		this._slideSelector = options.slideSelector || '.slider_slide';
		this._transitionTopWidthArr = options.transitionTopWidthArr || [];
		this._transitionOpacityWidthArr = options.transitionOpacityWidthArr || [];
		this._transitionInProcessClass = options.transitionInProcessClass || '';
		this._customMoveCheck = options.customMoveCheck || false
		this._sliderActiveWidthArr = this._transitionTopWidthArr.concat(this._transitionOpacityWidthArr);
	
		this._onClick = this._onClick.bind(this);
		this._onTransitionTopEnd = this._onTransitionTopEnd.bind(this);
		this._onTransitionOpacity1End = this._onTransitionOpacity1End.bind(this);
		this._onTransitionOpacity2End = this._onTransitionOpacity2End.bind(this);
		this._onWindowResize = this._onWindowResize.bind(this);
	
		this._init();
	}
	
	SimpleVerticalSlider.prototype = Object.create(Helper.prototype);
	SimpleVerticalSlider.prototype.constructor = SimpleVerticalSlider;
	
	SimpleVerticalSlider.prototype._init = function() {
		this._overflowContainer = this._elem.querySelector(this._overflowHiddenContainerSelector);
		this._overflowBlock = this._overflowContainer.querySelector(this._overflowContainerSelector);
		this._sidesArr = this._overflowBlock.querySelectorAll(this._slideSelector);
	
		this._setInitialPosition();
	
		this._addListener(this._elem, 'click', this._onClick);
		this._addListener(window, 'resize', this._onWindowResize);
	};
	
	SimpleVerticalSlider.prototype._setInitialPosition = function() {
		this._removeListener(this._elem, 'transitionend', this._onTransitionTopEnd);
		this._removeListener(this._elem, 'transitionend', this._onTransitionOpacity1End);
		this._removeListener(this._elem, 'transitionend', this._onTransitionOpacity2End);
	
		this._activeSlideIndex = 0;
		var slide = this._sidesArr[this._activeSlideIndex];
	
		this._setVendorCss(this._overflowBlock, 'transition', '');
		for (var i = 0; i < this._sidesArr.length; i++) {
			this._setVendorCss(this._sidesArr[i], 'transition', '');
			this._sidesArr[i].style.opacity = '';
		}
	
		var offsetTop = slide.offsetTop;
		var offsetHeight = slide.offsetHeight;
		this._overflowBlock.style.top = -offsetTop + 'px';
		this._overflowContainer.style.height = slide.offsetHeight + 'px';
	
		this._setActiveSliderControll(this._activeSlideIndex);
	
		this._transitionInProgress = false;
		if (this._transitionInProcessClass) {
			this._elem.classList.remove(this._transitionInProcessClass);
		}
	};
	
	SimpleVerticalSlider.prototype._moveSlide = function(index) {
		var success = false;
	
		if (this._transitionInProgress) return success;
	
		if (this._customMoveCheck && !this._customMoveCheck(this, index, this._sidesArr, this._elem)) return success;
	
		if (this._transitionOpacityWidthArr.indexOf(this._checkScreenWidth()) !== -1) {
			success = this._moveSlideWithOpacity(index);
		} else if (this._transitionTopWidthArr.indexOf(this._checkScreenWidth()) !== -1) {
			success = this._moveSlideWithScroll(index);
		}
	
		return success;
	};
	
	SimpleVerticalSlider.prototype._moveSlideWithScroll = function(index) {
		var slide = this._sidesArr[index];
		if (!slide || index === this._activeSlideIndex) return false;
	
		this._currentTransitionElem = this._overflowBlock;
		this._currentTransitionProp = 'top';
	
		this._activeSlideIndex = index;
	
		this._setVendorCss(this._currentTransitionElem, 'transition', this._currentTransitionProp + ' ease ' + this._transitionDuration + 's');
	
		this._addListener(this._elem, 'transitionend', this._onTransitionTopEnd);
	
		this._transitionInProgress = true;
		if (this._transitionInProcessClass) {
			this._elem.classList.add(this._transitionInProcessClass);
		}
	
		var offsetTop = slide.offsetTop;
		var offsetHeight = slide.offsetHeight;
		this._currentTransitionElem.style[this._currentTransitionProp] = -offsetTop + 'px';
		this._overflowContainer.style.height = slide.offsetHeight + 'px';
		return true;
	};
	
	SimpleVerticalSlider.prototype._onTransitionTopEnd = function(e) {
		var target = e.target;
		var prop = e.propertyName;
		if (!target || target !== this._currentTransitionElem || !prop || prop !== this._currentTransitionProp) return;
	
		this._removeListener(this._elem, 'transitionend', this._onTransitionTopEnd);
	
		this._setVendorCss(this._currentTransitionElem, 'transition', '');
	
		delete this._currentTransitionElem;
		delete this._currentTransitionProp;
	
		this._transitionInProgress = false;
		if (this._transitionInProcessClass) {
			this._elem.classList.remove(this._transitionInProcessClass);
		}
	};
	
	SimpleVerticalSlider.prototype._moveSlideWithOpacity = function(index) {
		var slide = this._sidesArr[index];
		if (!slide || index === this._activeSlideIndex) return false;
	
		this._currentTransitionElem = this._sidesArr[this._activeSlideIndex];
		this._currentTransitionProp = 'opacity';
	
		this._activeSlideIndex = index;
	
		this._setVendorCss(this._currentTransitionElem, 'transition', this._currentTransitionProp + ' ease ' + (this._transitionDuration / 2) + 's');
	
		this._addListener(this._elem, 'transitionend', this._onTransitionOpacity1End);
	
		this._transitionInProgress = true;
		if (this._transitionInProcessClass) {
			this._elem.classList.add(this._transitionInProcessClass);
		}
	
		this._currentTransitionElem.style[this._currentTransitionProp] = 0;
		slide.style[this._currentTransitionProp] = 0;
	
		return true;
	};
	
	SimpleVerticalSlider.prototype._onTransitionOpacity1End = function(e) {
		var target = e.target;
		var prop = e.propertyName;
		if (!target || target !== this._currentTransitionElem || !prop || prop !== this._currentTransitionProp) return;
	
		this._removeListener(this._elem, 'transitionend', this._onTransitionOpacity1End);
		this._addListener(this._elem, 'transitionend', this._onTransitionOpacity2End);
	
		var prevTransElem = this._currentTransitionElem;
		this._currentTransitionElem = this._sidesArr[this._activeSlideIndex];
	
		this._setVendorCss(prevTransElem, 'transition', '');
		this._setVendorCss(this._currentTransitionElem, 'transition', this._currentTransitionProp + ' ease ' + (this._transitionDuration / 2) + 's');
	
		var offsetTop = this._currentTransitionElem.offsetTop;
		var offsetHeight = this._currentTransitionElem.offsetHeight;
		this._overflowBlock.style.top = -offsetTop + 'px';
		this._overflowContainer.style.height = offsetHeight + 'px';
		this._currentTransitionElem.style[this._currentTransitionProp] = '';
		prevTransElem.style[this._currentTransitionProp] = '';
	};
	
	SimpleVerticalSlider.prototype._onTransitionOpacity2End = function(e) {
		var target = e.target;
		var prop = e.propertyName;
		if (!target || target !== this._currentTransitionElem || !prop || prop !== this._currentTransitionProp) return;
	
		this._removeListener(this._elem, 'transitionend', this._onTransitionOpacity2End);
	
		this._setVendorCss(this._currentTransitionElem, 'transition', '');
	
		delete this._currentTransitionElem;
		delete this._currentTransitionProp;
	
		this._transitionInProgress = false;
		if (this._transitionInProcessClass) {
			this._elem.classList.remove(this._transitionInProcessClass);
		}
	};
	
	SimpleVerticalSlider.prototype._onWindowResize = function() {
		var activeWidth = this._sliderActiveWidthArr.indexOf(this._checkScreenWidth()) !== -1;
	
		if (this._active && !activeWidth) {
			this._active = false;
			return;
		} else if (!this._active && !activeWidth) {
			return;
		} else if (!this._active && activeWidth) {
			this._active = true;
			this._setInitialPosition();
		}
	
		var slide = this._sidesArr[this._activeSlideIndex];
		var offsetTop = slide.offsetTop;
		var offsetHeight = slide.offsetHeight;
		this._overflowBlock.style.top = -offsetTop + 'px';
		this._overflowContainer.style.height = offsetHeight + 'px';
	};
	
	SimpleVerticalSlider.prototype._onClick = function(e) {
		var target = e.target;
		if (!target) return;
	
		var actionElem = target.closest(this._controllsSelector + '[data-action][data-target-slide-index]');
		if (!actionElem) return;
	
		var action = actionElem.dataset.action;
		var targetSlideIndex = parseInt(actionElem.dataset.targetSlideIndex);
		if (!action || targetSlideIndex !== targetSlideIndex) return;
	
		if (action === 'change-slide') {
			e.preventDefault();
			if (this._moveSlide(targetSlideIndex)) {
				this._setActiveSliderControll(targetSlideIndex);
			}
		}
	};
	
	SimpleVerticalSlider.prototype._setActiveSliderControll = function(slideIndex) {
		var sliderControlls = this._elem.querySelectorAll(this._controllsSelector + '[data-action="change-slide"][data-target-slide-index]'),
			activeControllFound = false;
	
		for (var i = 0, targetSlideIndex; i < sliderControlls.length; i++) {
			targetSlideIndex = parseInt(sliderControlls[i].dataset.targetSlideIndex);
	
			if (!activeControllFound && targetSlideIndex === slideIndex) {
				activeControllFound = true;
				sliderControlls[i].classList.add('active');
			} else {
				sliderControlls[i].classList.remove('active');
			}
		}
	
		return activeControllFound;
	};
	
	try {
		module.exports = SimpleVerticalSlider;
	} catch (err) {
		console.warn(err);
	}


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	try {
		var Slider = __webpack_require__(9);
		var SliderControlls = __webpack_require__(10);
	} catch (err) {
		console.warn(err);
	}
	
	function SliderWithControlls(options) {
		this._controllsSelector = options.controllsSelector;
		this._decorationItems = !!options.decorationItems;
	
		options.name = options.name || 'SliderWithControlls';
		Slider.call(this, options);
	}
	
	SliderWithControlls.prototype = Object.create(Slider.prototype);
	SliderWithControlls.prototype.constructor = SliderWithControlls;
	
	SliderWithControlls.prototype._init = function() {
		Slider.prototype._init.apply(this, arguments);
	
		this._initControlls();
	};
	
	SliderWithControlls.prototype._initControlls = function() {
		if (!this._controllsSelector) return;
	
		var sliderControllsElem = document.querySelector(this._controllsSelector);
		if (sliderControllsElem) {
			this._sliderControlls = new SliderControlls({
				elem: sliderControllsElem,
				slidesCount: this.getSlidesCount(),
				slider: this,
				decorationItems: this._decorationItems
			});
		}
	};
	
	try {
		module.exports = SliderWithControlls;
	} catch (err) {
		console.warn(err);
	}


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	try {
		var Helper = __webpack_require__(4);
	} catch (err) {
		console.warn(err);
	}
	
	function Slider(options) {
		options.name = options.name || 'Slider';
		Helper.call(this, options);
	
		this._elem = options.elem;
		this._overflowContainer = this._elem.querySelector('.overflow_hidden_container');
		this._overflowBlock = this._overflowContainer.querySelector('.overflow_block');
		this._moveDelay = options.delay || 0;
	//	this._breakPoint = options.breakPoint || 0;
		this._breakPoint = {};
		if (typeof options.breakPoint === 'number') {
			this._breakPoint.min = options.breakPoint;
			this._breakPoint.max = false;
		} else {
			this._breakPoint.min = options.breakPoint.min || 0;
			this._breakPoint.max = typeof options.breakPoint.max === 'number' ? options.breakPoint.max : false;
		}
		this._pauseOnHover = !!options.pauseOnHover || false;
		this._listenToOuterControllEvents = options.listenToOuterControllEvents !== undefined ? !!options.listenToOuterControllEvents : true;
		this._allowTouchDrag = options.allowTouchDrag !== undefined ? !!options.touchDrag : true;
	
		this._onClick = this._onClick.bind(this);
		this._onCornerTransitionEnd = this._onCornerTransitionEnd.bind(this);
		this._onMiddleTransitionEnd = this._onMiddleTransitionEnd.bind(this);
		this._onMouseOver = this._onMouseOver.bind(this);
		this._onMouseOut = this._onMouseOut.bind(this);
		this._onMouseDown = this._onMouseDown.bind(this);
		this._onMouseUp = this._onMouseUp.bind(this);
		this._onDragStart = this._onDragStart.bind(this);
		this._onMouseMoveDrag = this._onMouseMoveDrag.bind(this);
		this._onSliderControl = this._onSliderControl.bind(this);
		this._onResize = this._onResize.bind(this);
	
		this._init();
	}
	
	Slider.prototype = Object.create(Helper.prototype);
	Slider.prototype.constructor = Slider;
	
	Slider.prototype._init = function() {
		var slidesArr = this._overflowBlock.querySelectorAll('[data-component="slide"]');
		this._slidesCount = slidesArr.length;
	
		this._currSlide = 1;
	
		if (this._checkScreenWidth(this._breakPoint.min, this._breakPoint.max)) {
			this._active = true;
	
			this._initSlider();
	
		} else {
			this._active = false;
		}
	
		this._addListener(window, 'resize', this._onResize);
	};
	
	Slider.prototype._initSlider = function() {
		var slidesArr = this._overflowBlock.querySelectorAll('[data-component="slide"]');
		if (0 === slidesArr.length) return;
	
		this._slidesCount = slidesArr.length;
	
		var firstSlide = slidesArr[0];
		var lastSlide = slidesArr[slidesArr.length - 1];
	
		this._overflowBlock.insertBefore(lastSlide.cloneNode(true), this._overflowBlock.firstChild);
		this._overflowBlock.appendChild(firstSlide.cloneNode(true));
	
		this._slidesArr = Array.prototype.slice.call(this._overflowBlock.querySelectorAll('[data-component="slide"]'));
		for (var i = 0; i < this._slidesArr.length; i++) {
			this._slidesArr[i].style.width = 100 / (this._slidesCount + 2) + '%';
			this._slidesArr[i].classList.remove('selected');
		}
	
		this._currSlide = 1;
		this._setSelectedClass(this._currSlide);
		this._overflowBlock.style.width = 100 * (this._slidesCount + 2) + '%';
		this._overflowBlock.style.left = '-100%';
	
		this._sendCustomEvent(this._elem, 'sliderSlideChanged', { bubbles: true, detail: {slideIndex: this._currSlide, slider: this, sliderElem: this._elem} });
	
		this._addListener(this._elem, 'click', this._onClick);
		if (this._pauseOnHover) {
			this._addListener(this._elem, 'mouseover', this._onMouseOver);
			this._addListener(this._elem, 'mouseout', this._onMouseOut);
		}
	
		if (this._listenToOuterControllEvents) {
			this._addListener(document, 'sliderControl', this._onSliderControl);
		}
	
		if (0 !== this._moveDelay) this._moveOverTime();
	
		this._moveOnSwipe();
	};
	
	Slider.prototype._onSliderControl = function(e) {
		var targetSlider = e.detail.targetSlider;
		var slideIndex = e.detail.slideIndex;
		var controlls = e.detail.controlls;
		if (
			(typeof targetSlider === 'string' && this._elem.matches(targetSlider)) ||
			(targetSlider instanceof Slider && targetSlider === this) ||
			(targetSlider instanceof Element && targetSlider === this._elem)
		) {
			if (this._isMoving || slideIndex === undefined || this._sliderContrlolls !== controlls) return;
	
			if (this._currSlide < slideIndex) {
				this._moveSlideForward(slideIndex - this._currSlide);
			} else if (this._currSlide > slideIndex) {
				this._moveSlideBack(this._currSlide - slideIndex);
			}
		}
	};
	
	Slider.prototype._cancelInitSlider = function() {
		if (this._moveTimer) {
			clearTimeout(this._moveTimer);
		}
	
		for (var i = this._listenerArr.length - 1; i >= 0 ; i--) {
			if (
				this._listenerArr[i].elem !== window
				|| this._listenerArr[i].event !== 'resize'
				|| this._listenerArr[i].handler !== this._onResize
			) {
				this._removeListener(this._listenerArr[i].elem, this._listenerArr[i].event, this._listenerArr[i].handler, this._listenerArr[i].phase);
			}
		}
	
		if (this._slidesArr.length > 0) {
			this._slidesArr[0].parentElement.removeChild(this._slidesArr[0]);
			this._slidesArr[this._slidesArr.length - 1].parentElement.removeChild(this._slidesArr[this._slidesArr.length - 1]);
		}
	
		this._overflowBlock.style.width = '';
		this._overflowBlock.style.left = '';
	
		this._slidesArr = Array.prototype.slice.call(this._overflowBlock.querySelectorAll('[data-component="slide"]'));
		for (var i = 0; i < this._slidesArr.length; i++) {
			this._slidesArr[i].style.width = '';
			this._slidesArr[i].classList.remove('selected');
		}
	
		this._isMoving = false;
	};
	
	Slider.prototype._setSelectedClass = function(slideIndex) {
		for (var i = 0; i < this._slidesArr.length; i++) {
			this._slidesArr[i].classList.remove('selected');
		}
	
		this._slidesArr[slideIndex].classList.add('selected');
		if (slideIndex === 0) {
			this._slidesArr[this._slidesArr.length - 2].classList.add('selected');
		} else if (slideIndex === 1) {
			this._slidesArr[this._slidesArr.length - 1].classList.add('selected');
		} else if (slideIndex === this._slidesArr.length - 1) {
			this._slidesArr[1].classList.add('selected');
		} else if (slideIndex === this._slidesArr.length - 2) {
			this._slidesArr[0].classList.add('selected');
		}
	};
	
	Slider.prototype._onClick = function(e) {
		var target = e.target;
		this._controlSlider(target, e);
	};
	
	Slider.prototype._controlSlider = function(target, e) {
		var control = target.closest('[data-component="slider_control"]');
		if (control) {
			e.preventDefault();
			if (this._isMoving) return;
	
			if (this._moveTimer) {
				clearTimeout(this._moveTimer);
			}
			switch (control.dataset.action) {
				case 'forward':
					this._moveSlideForward();
					break;
				case 'back':
					this._moveSlideBack();
					break;
			}
	
			if (0 !== this._moveDelay) this._moveOverTime();
		}
	};
	
	Slider.prototype._onMouseOver = function() {
		if (this._moveTimer) {
			clearTimeout(this._moveTimer);
		}
	};
	
	Slider.prototype._onMouseOut = function() {
		if (0 !== this._moveDelay) this._moveOverTime();
	};
	
	Slider.prototype._moveSlideForward = function(increment) {
		increment = (increment === undefined) ? 1 : increment;
		this._overflowBlock.style.transitionDuration = '';
		this._isMoving = true;
	
		this._currSlide += increment;
	
		this._setSelectedClass(this._currSlide);
	
		this._overflowBlock.style.left = -100 * this._currSlide + '%';
	
		if (this._currSlide > this._slidesCount) {
			this._currSlide = 1;
			this._setSelectedClass(this._currSlide);
			this._addListener(this._elem, 'transitionend', this._onCornerTransitionEnd);
		} else {
			this._addListener(this._elem, 'transitionend', this._onMiddleTransitionEnd);
		}
	
		this._sendCustomEvent(this._elem, 'sliderSlideChanged', { bubbles: true, detail: {slideIndex: this._currSlide, slider: this, sliderElem: this._elem} });
	};
	
	Slider.prototype._moveSlideBack = function(decrement) {
		decrement = (decrement === undefined) ? 1 : decrement;
		this._overflowBlock.style.transitionDuration = '';
		this._isMoving = true;
	
		this._currSlide -= decrement;
	
		this._setSelectedClass(this._currSlide);
	
		this._overflowBlock.style.left = -100 * this._currSlide + '%';
	
		if (0 === this._currSlide) {
			this._currSlide = this._slidesCount;
			this._setSelectedClass(this._currSlide);
			this._addListener(this._elem, 'transitionend', this._onCornerTransitionEnd);
		} else {
			this._addListener(this._elem, 'transitionend', this._onMiddleTransitionEnd);
		}
	
		this._sendCustomEvent(this._elem, 'sliderSlideChanged', { bubbles: true, detail: {slideIndex: this._currSlide, slider: this, sliderElem: this._elem} });
	};
	
	Slider.prototype._onMiddleTransitionEnd = function(e) {
		if (e.target !== this._overflowBlock) return;
	
		this._removeListener(this._elem, 'transitionend', this._onMiddleTransitionEnd);
		this._isMoving = false;
	};
	
	Slider.prototype._onCornerTransitionEnd = function(e) {
		if (e.target !== this._overflowBlock) return;
	
		this._removeListener(this._elem, 'transitionend', this._onCornerTransitionEnd);
	
		this._overflowBlock.style.transitionDuration = '0s';
		this._overflowBlock.style.left = -100 * (this._currSlide) + '%';
		this._isMoving = false;
	};
	
	Slider.prototype._moveOnSwipe = function() {
		this._addListener(this._elem, 'mousedown', this._onMouseDown);
		this._addListener(this._elem, 'touchstart', this._onMouseDown);
		this._addListener(this._elem, 'dragstart', this._onDragStart);
	};
	
	Slider.prototype._onDragStart = function(e) {
		e.preventDefault();
	};
	
	Slider.prototype._onMouseDown = function(e) {
		var target = e.target;
		if (!target) {
			return;
		}
		var control = target.closest('[data-component="slider_control"]');
		if (!control) {
			this._startDrag(e);
		}
	};
	
	Slider.prototype._onMouseUp = function(e) {
		this._stopDrag(e);
	};
	
	Slider.prototype._startDrag = function(e) {
		this._removeListener(this._elem, 'transitionend', this._onCornerTransitionEnd);
		this._removeListener(this._elem, 'transitionend', this._onMiddleTransitionEnd);
		this._removeListener(this._elem, 'mousedown', this._onMouseDown);
		this._removeListener(this._elem, 'touchstart', this._onMouseDown);
	
		if (this._moveTimer) {
			clearTimeout(this._moveTimer);
		}
	
		this._isMoving = false;
		this._overflowBlock.style.transitionDuration = '0s';
	
		var clientX = (e.clientX === undefined) ? e.changedTouches[0].clientX : e.clientX;
		var clientY = (e.clientY === undefined) ? e.changedTouches[0].clientY : e.clientY;
	
		this._startCursorXPosition = clientX + (window.pageXOffset || document.documentElement.scrollLeft);
		this._startCursorYPosition = clientY + (window.pageYOffset || document.documentElement.scrollTop);
	
		this._overflowStartLeft = this._overflowBlock.offsetLeft;
	
		this._addListener(document, 'mousemove', this._onMouseMoveDrag);
		this._addListener(document, 'touchmove', this._onMouseMoveDrag);
		this._addListener(document, 'mouseup', this._onMouseUp);
		this._addListener(document, 'touchend', this._onMouseUp);
	};
	
	Slider.prototype._stopDrag = function(e) {
		this._removeListener(document, 'mousemove', this._onMouseMoveDrag);
		this._removeListener(document, 'touchmove', this._onMouseMoveDrag);
		this._removeListener(document, 'mouseup', this._onMouseUp);
		this._removeListener(document, 'touchend', this._onMouseUp);
	
		var pxLeft = getComputedStyle(this._overflowBlock).left;
		var pxIntLeft = parseInt(pxLeft);
		var percentLeft = this._pixelsToPercents(pxIntLeft);
	
		this._overflowBlock.style.left = percentLeft + '%';
	
		var clientX = (e.clientX === undefined) ? e.changedTouches[0].clientX : e.clientX;
		var clientY = (e.clientY === undefined) ? e.changedTouches[0].clientY : e.clientY;
	
		if (this._startCursorXPosition !== clientX || this._startCursorYPosition !== clientY) {
			e.preventDefault();
		}
	
		this._addListener(this._elem, 'mousedown', this._onMouseDown);
		this._addListener(this._elem, 'touchstart', this._onMouseDown);
	
		var newCenterSlide = this._getCenterListItem();
		var diff;
		if (!newCenterSlide) {
			console.warn(this.NAME + ': Center slide is not found!');
			diff = 0;
	
		} else {
			var newCenterSlideIndex = this._slidesArr.indexOf(newCenterSlide);
	
			if (newCenterSlideIndex === -1) {
				console.warn(this.NAME + ': Center slide is not in slides Array!');
				diff = 0;
	
			} else {
				diff = newCenterSlideIndex - this._currSlide;
			}
		}
	
		if (diff >= 0) {
			var overflowLeft = getComputedStyle(this._overflowBlock).left;
			var overflowLeftInt = parseInt(overflowLeft);
			var percentLeft = this._pixelsToPercents(overflowLeftInt);
			if ((diff === 0) && (parseInt(percentLeft * 10) % 100 === 0)) {
	
			} else {
				this._moveSlideForward(diff);
			}
	
		} else {
			this._moveSlideBack(-diff);
		}
	
		if (0 !== this._moveDelay) this._moveOverTime();
	};
	
	Slider.prototype._pixelsToPercents = function(left) {
		return left * (100 / this._overflowContainer.clientWidth);
	};
	
	Slider.prototype._onMouseMoveDrag = function(e) {
		var clientX = (e.clientX === undefined) ? e.changedTouches[0].clientX : e.clientX;
	
		var currentcursorXPosition = clientX + (window.pageXOffset || document.documentElement.scrollLeft);
		var xPositionDeleta = currentcursorXPosition - this._startCursorXPosition;
	
		var newLeft = this._overflowStartLeft + xPositionDeleta;
	
		this._overflowBlock.style.left = newLeft + 'px';
	
		var newCenterSlide = this._getCenterListItem();
		if (!newCenterSlide) {
	
		} else {
			var newCenterSlideIndex = this._slidesArr.indexOf(newCenterSlide);
	
			if (newCenterSlideIndex === -1) {
	
			} else {
	
				if (newCenterSlideIndex > this._slidesCount) {
					var percentLeft = this._pixelsToPercents(newLeft);
					newLeft = Math.abs(percentLeft) % 100;
					this._overflowBlock.style.left = -newLeft + '%';
	
					this._startCursorXPosition = currentcursorXPosition;
					this._overflowStartLeft = this._overflowBlock.offsetLeft;
	
				} else if (newCenterSlideIndex === 0) {
					var percentLeft = this._pixelsToPercents(newLeft);
					newLeft = Math.abs(percentLeft) + (this._slidesCount * 100);
					this._overflowBlock.style.left = -newLeft + '%';
	
					this._startCursorXPosition = currentcursorXPosition;
					this._overflowStartLeft = this._overflowBlock.offsetLeft;
				}
			}
		}
	};
	
	Slider.prototype._getCenterListItem = function() {
		var clientRect = this._overflowContainer.getBoundingClientRect();
	
		var overflowContainerCenter = {
			x: clientRect.left + this._overflowContainer.offsetWidth / 2,
			y: clientRect.top + this._overflowContainer.offsetHeight / 2
		}
	
		if (overflowContainerCenter.x < 0) {
			overflowContainerCenter.x = 0;
		} else if (overflowContainerCenter.x > window.innerWidth - 1) {
			overflowContainerCenter.x = window.innerWidth - 1;
		}
	
		if (overflowContainerCenter.y < 0) {
			overflowContainerCenter.y = 0;
		} else if (overflowContainerCenter.y > window.innerHeight - 1) {
			overflowContainerCenter.y = window.innerHeight - 1;
		}
	
		var centerElement = document.elementFromPoint(overflowContainerCenter.x, overflowContainerCenter.y);
	
		return centerElement.closest('[data-component="slide"]');
	};
	
	Slider.prototype._moveOverTime = function() {
		this._moveTimer = setTimeout(function() {
			if (!this._elem) return;
			if (!this._isMoving) {
				this._moveSlideForward();
			}
			this._moveOverTime();
		}.bind(this), this._moveDelay);
	};
	
	Slider.prototype._onResize = function() {
		if (this._checkScreenWidth(this._breakPoint.min, this._breakPoint.max) && !this._active) {
			this._active = true;
			this._initSlider();
	
		} else if (!this._checkScreenWidth(this._breakPoint.min, this._breakPoint.max) && this._active) {
			this._active = false;
			this._cancelInitSlider();
		}
	};
	
	Slider.prototype.getSlidesCount = function() {
		return this._slidesCount;
	};
	
	Slider.prototype.getActiveSlideIndex = function() {
		return this._currSlide;
	};
	
	try {
		module.exports = Slider;
	} catch (err) {
		console.warn(err);
	}


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	try {
		var Helper = __webpack_require__(4);
		var Animation = __webpack_require__(11);
	} catch (err) {
		console.warn(err);
	}
	
	function SliderControlls(options) {
		options.name = options.name || 'SliderControlls';
		Helper.call(this, options);
	
		this._elem = options.elem;
		this._slidesCount = options.slidesCount;
		this._animationDuration = options.animationDuration || 500;
		this._slider = options.slider;
		this._sliderElem = options.sliderElem;
		this._sliderSelector = options.sliderSelector;
		this._decorationItems = !!options.decorationItems;
	
		this._onClick = this._onClick.bind(this);
		this._onSliderSlideChanged = this._onSliderSlideChanged.bind(this);
	
		this._init();
	}
	
	SliderControlls.prototype = Object.create(Helper.prototype);
	SliderControlls.prototype.constructor = SliderControlls;
	
	SliderControlls.prototype._init = function() {
		this._listElem = this._elem.querySelector('.slider_dot_controlls_list');
	//	this._listElem = this._elem;
		if (!this._listElem) return;
	
		this._listElem.innerHTML = this._createList();
		this._controllsElemsArr = this._listElem.querySelectorAll('.slider_dot_controll');
		this._controllsVisible = false;
	
		this._setActive(this._slider.getActiveSlideIndex());
	
		this._addListener(this._elem, 'click', this._onClick);
		this._addListener(document, 'sliderSlideChanged', this._onSliderSlideChanged);
	};
	
	SliderControlls.prototype._createList = function() {
		var listHtml = '',
			listItemHtml = '<li class="slider_dot_controll" data-component="slider_control" data-slide-index="{index}"></li>',
			listItemDcorationHtml = '<li class="dot_controll_decoration"></li>';
	
		for (var i = 0; i < this._slidesCount; i++) {
			if (this._decorationItems && i > 0) {
				listHtml += listItemDcorationHtml;
			}
			listHtml += listItemHtml.replace('{index}', i + 1);
		}
	
		return listHtml;
	};
	
	SliderControlls.prototype._onClick = function(e) {
		var target = e.target;
	
		this._controlSlider(target);
	};
	
	SliderControlls.prototype._onSliderSlideChanged = function(e) {
		var slideIndex = e.detail.slideIndex;
		var slider = e.detail.slider;
		if (slideIndex === undefined || this._slider !== slider) return;
	
		this._setActive(slideIndex);
	};
	
	SliderControlls.prototype._setActive = function(index) {
		for (var i = 0; i < this._controllsElemsArr.length; i++) {
			this._controllsElemsArr[i].classList.remove('active');
		}
	
		var activeControll = this._listElem.querySelector('[data-slide-index="' + index + '"]');
		if (activeControll) {
			activeControll.classList.add('active');
		}
	};
	
	SliderControlls.prototype._controlSlider = function(target) {
		var control = target.closest('[data-component="slider_control"]');
		if (!control) return;
		var slideIndex = control.dataset.slideIndex;
		if (!slideIndex) return;
	
		var targetSlider = this._slider || this._sliderElem || this._sliderSelector || false;
		this._sendCustomEvent(document, 'sliderControl', { bubbles: true, detail: {slideIndex: parseInt(slideIndex), targetSlider: targetSlider} });
	};
	
	SliderControlls.prototype.show = function() {
		this.visible = true;
	
		if (this._animation) {
			this._animation.stop(true);
			delete this._animation;
		}
	
		this._elem.classList.remove('hidden');
	
		this._animation = new Animation(
			function(timePassed) {
				var timeMuliplier = Animation.linear(this._animationDuration, timePassed);
	
				this._elem.style.opacity = timeMuliplier;
			}.bind(this),
			this._animationDuration,
			function() {
				delete this._animation;
			}.bind(this)
		);
	};
	
	SliderControlls.prototype.hide = function() {
		this.visible = false;
	
		if (this._animation) {
			this._animation.stop(true);
			delete this._animation;
		}
	
		this._animation = new Animation(
			function(timePassed) {
				var timeMuliplier = Animation.linear(this._animationDuration, timePassed);
	
				this._elem.style.opacity = 1 - timeMuliplier;
			}.bind(this),
			this._animationDuration,
			function() {
				delete this._animation;
				this._elem.classList.add('hidden');
			}.bind(this)
		);
	};
	
	try {
		module.exports = SliderControlls;
	} catch (err) {
		console.warn(err);
	}


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	try {
		var Helper = __webpack_require__(4);
	} catch (err) {
		console.warn(err);
	}
	
	function Animation(draw, duration, callback) {
		Helper.call(this, { name: 'Animation', noId: true });
	
		var start = performance.now();
		var self = this;
		var timeSincePaused = 0;
		var totalPrevPauseDuration = 0;
		var pauseStartedAt;
	
		this._state = 'playing';
		this._callback = callback;
	
		this._requestId = requestAnimationFrame(function animate(time) {
			delete self._requestId;
	
			if (self._requestToPause) {
				delete self._requestToPause;
	
				if (self._state !== 'paused') {
					self._state = 'paused';
					pauseStartedAt = time;
				}
			}
	
			if (self._requestToPlay) {
				delete self._requestToPlay;
	
				if (self._state !== 'playing') {
					self._state = 'playing';
					totalPrevPauseDuration = timeSincePaused;
				}
			}
	
			if (self._state === 'paused') {
				timeSincePaused = time - pauseStartedAt + totalPrevPauseDuration;
			}
	
			// определить, сколько прошло времени с начала анимации
			var timePassed = time - (start + timeSincePaused);
	
			// возможно небольшое превышение времени, в этом случае зафиксировать конец
			if (timePassed < 0) {
				timePassed = 0;
			} else if (timePassed > duration) {
				timePassed = duration;
			}
	
			// нарисовать состояние анимации в момент timePassed
			draw(timePassed);
	
			// если время анимации не закончилось - запланировать ещё кадр
			if (timePassed < duration && !self._requestToStop) {
				self._requestId = requestAnimationFrame(animate);
			} else {
				self._state = 'ended';
				self._excuteCallback = (self._excuteCallback === undefined ? true : self._excuteCallback);
			}
	
			if (self._excuteCallback && self._callback) {
				self._callback();
			}
	
			if (self._state === 'ended') {
				Helper.prototype.remove.apply(self, arguments);
			}
		});
	}
	
	Animation.prototype = Object.create(Helper.prototype);
	Animation.prototype.constructor = Animation;
	
	Animation.prototype._stopBeforeAnimate = function() {
		cancelAnimationFrame(this._requestId);
		this._state = 'ended';
	
		if (this._excuteCallback && this._callback) {
			this._callback();
		}
	
		Helper.prototype.remove.apply(this, arguments);
	};
	
	Animation.prototype._stopWithinAnimate = function() {
		this._requestToStop = true;
	};
	
	Animation.prototype.stop = function(executeCallback) {
		this._excuteCallback = !!executeCallback;
	
		if (this._requestId !== undefined) {
			this._stopBeforeAnimate();
		} else {
			this._stopWithinAnimate();
		}
	};
	
	Animation.prototype.pause = function() {
		this._requestToPause = true;
	};
	
	Animation.prototype.play = function() {
		this._requestToPlay = true;
	};
	
	Animation._progress = function(fullDuration, timePassed) {
		var progress;
	
		if (fullDuration === 0) {
			progress = 1;
		} else {
			progress = timePassed / fullDuration;
		}
	
		return progress;
	};
	
	Animation.linear = function(fullDuration, timePassed) {
		return this._progress(fullDuration, timePassed);
	};
	
	Animation.quadEaseIn = function(fullDuration, timePassed) {
		var progress = this._progress(fullDuration, timePassed);
		return Math.pow(progress, 2);
	};
	
	Animation.circEaseIn = function(fullDuration, timePassed) {
		var progress = this._progress(fullDuration, timePassed);
		return 1 - Math.sin(Math.acos(progress));
	};
	
	Animation.quadEaseOut = function(fullDuration, timePassed) {
		var progress = 1 - this._progress(fullDuration, timePassed);
		return 1 - Math.pow(progress, 2);
	};
	
	Animation.circEaseOut = function(fullDuration, timePassed) {
		var progress = 1 - this._progress(fullDuration, timePassed);
		return Math.sin(Math.acos(progress));
	};
	
	Animation.quadEaseInOut = function(fullDuration, timePassed) {
		var halfDuration = fullDuration / 2,
			timeFraction;
	
		if (halfDuration > timePassed) {
			timeFraction = this.quadEaseIn(halfDuration, timePassed) / 2;
	
		} else {
			var secondHalfTimePassed = timePassed - halfDuration;
			timeFraction = 0.5 + (this.quadEaseOut(halfDuration, secondHalfTimePassed) / 2);
	
		}
	
		return timeFraction;
	};
	
	Animation.circEaseInOut = function(fullDuration, timePassed) {
		var halfDuration = fullDuration / 2,
			timeFraction;
	
		if (halfDuration > timePassed) {
			timeFraction = this.circEaseIn(halfDuration, timePassed) / 2;
	
		} else {
			var secondHalfTimePassed = timePassed - halfDuration;
			timeFraction = 0.5 + (this.circEaseOut(halfDuration, secondHalfTimePassed) / 2);
	
		}
	
		return timeFraction;
	};
	
	//Animation.customBezier = function(fullDuration, timePassed, C1, C2, C3, C4) {
	//	var progress = this._progress(fullDuration, timePassed);
	//	return this._bezier(C1, C2, C3, C4, progress);
	//};
	//
	//Animation.ease = function(fullDuration, timePassed) {
	//	var progress = this._progress(fullDuration, timePassed);
	////	return this._bezier(0.25, 0.1, 0.25, 1, progress);
	//	return this._bezier(0, 0.25, 0.25, 1, progress);
	//};
	//
	//Animation.easeIn = function(fullDuration, timePassed) {
	//	var progress = this._progress(fullDuration, timePassed);
	////	return this._bezier(0.42, 0, 1, 1, progress);
	//	return this._bezier(0, 0.42, 1, 1, progress);
	//};
	//
	//Animation.easeOut = function(fullDuration, timePassed) {
	//	var progress = this._progress(fullDuration, timePassed);
	////	return this._bezier(0, 0, 0.58, 1, progress);
	//	return this._bezier(0, 0, 0.58, 1, progress);
	//};
	//
	//Animation.easeInOut = function(fullDuration, timePassed) {
	//	var progress = this._progress(fullDuration, timePassed);
	////	return this._bezier(0.42, 0, 0.58, 1, progress);
	//	return this._bezier(0, 0.42, 0.58, 1, progress);
	//};
	
	try {
		module.exports = Animation;
	} catch (err) {
		console.warn(err);
	}


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	try {
		var Helper = __webpack_require__(4);
	} catch (err) {
		console.warn(err);
	}
	
	function LangSwitcher(options) {
		options.name = options.name || 'LangSwitcher';
		Helper.call(this, options);
	
		this._langSelectElemsArr = options.langSelectElemsArr || [];
	
		this._onCustomSelect = this._onCustomSelect.bind(this);
	
		this._init();
	}
	
	LangSwitcher.prototype = Object.create(Helper.prototype);
	LangSwitcher.prototype.constructor = LangSwitcher;
	
	LangSwitcher.prototype._init = function() {
	    this._currentLang = this._getCookie('lang');
	
	    this._addListener(document, 'customselect', this._onCustomSelect);
	};
	
	LangSwitcher.prototype._onCustomSelect = function(e) {
	    var target = e.target;
	    if (!target || this._langSelectElemsArr.indexOf(target) === -1) return;
	
	    var newLang = e.detail.value;
	    if (!newLang || newLang === this._currentLang) return;
	
	    this._currentLang = newLang;
	
	    document.cookie = 'lang=' + newLang;
	
	    window.location.reload();
	};
	
	try {
		module.exports = LangSwitcher;
	} catch (err) {
		console.warn(err);
	}


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	try {
		var Helper = __webpack_require__(4);
	} catch (err) {
		console.warn(err);
	}
	
	function Popup(options) {
		options.name = options.name || 'Popup';
		Helper.call(this, options);
	
		this._elem = options.elem;
		this._popupOpenBtnSelector = options.popupOpenBtnSelector || '[data-popup-action="open"]';
		this._popupCloseBtnSelector = options.popupCloseBtnSelector || '[data-popup-action="close"]';
	
		this._onClick = this._onClick.bind(this);
		this._onFormSubmitted = this._onFormSubmitted.bind(this);
		this._onOpenPopup = this._onOpenPopup.bind(this);
		this._onClosePopup = this._onClosePopup.bind(this);
	
		this._init();
	}
	
	Popup.prototype = Object.create(Helper.prototype);
	Popup.prototype.constructor = Popup;
	
	Popup.prototype._init = function() {
		this._href = '';
	
		this._addListener(document, 'click', this._onClick);
		this._addListener(document, 'openPopup', this._onOpenPopup);
		this._addListener(document, 'closePopup', this._onClosePopup);
	};
	
	Popup.prototype._onClick = function(e) {
		var target = e.target;
		if (!target) return;
	
		var openBtn = target.closest(this._popupOpenBtnSelector);
		var closeBtn = target.closest(this._popupCloseBtnSelector);
	
		if (openBtn && openBtn.dataset.popupTarget && openBtn.dataset.popupTarget === this._elem.id) {
			e.preventDefault();
			this._href = target.href;
			this._openPopup();
	
		} else if (closeBtn && closeBtn.dataset.popupTarget && closeBtn.dataset.popupTarget === this._elem.id) {
			e.preventDefault();
			this._href = '';
			this._closePopup();
	
		}
	};
	
	Popup.prototype._openPopup = function() {
		this._elem.style.display = 'block';
		this._sendCustomEvent(this._elem, 'popupOpen', { bubbles: true, detail: { popupElem: this._elem } });
	
		this._addListener(this._elem, 'formSubmitted', this._onFormSubmitted);
	};
	
	Popup.prototype._closePopup = function() {
		this._elem.style.display = 'none';
		this._sendCustomEvent(this._elem, 'popupClosed', { bubbles: true, detail: { popupElem: this._elem } });
	
		this._removeListener(this._elem, 'formSubmitted', this._onFormSubmitted);
	};
	
	Popup.prototype._onFormSubmitted = function(e) {
		this._closePopup();
	
		window.location = this._href;
	};
	
	Popup.prototype._onOpenPopup = function(e) {
		var targetPopupElem = e.detail.targetPopupElem;
		if (targetPopupElem !== this._elem) return;
	
		this._openPopup();
	};
	
	Popup.prototype._onClosePopup = function(e) {
		var targetPopupElem = e.detail.targetPopupElem;
		if (targetPopupElem !== this._elem) return;
	
		this._closePopup();
	};
	
	try {
		module.exports = Popup;
	} catch (err) {
		console.warn(err);
	}


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	try {
		var FormTemplate = __webpack_require__(15);
		var ModalWindow = __webpack_require__(5);
		var _ajax = __webpack_require__(18);
	} catch (err) {
		console.warn(err);
	}
	
	function ContactFormController(options) {
		options.name = options.name || 'ContactFormController';
		FormTemplate.call(this, options);
	
		this._callback = options.callback;
	
		this._loadImages('img/spinner.gif');
	
		this._onSubmit = this._onSubmit.bind(this);
	
		this._addListener(this._elem, 'submit', this._onSubmit);
	}
	
	ContactFormController.prototype = Object.create(FormTemplate.prototype);
	ContactFormController.prototype.constructor = FormTemplate;
	
	ContactFormController.prototype._onSubmit = function(e) {
		e.preventDefault();
	
		if (this._waitingForResponse) {
			// console.log(this.NAME + ': Already sent form!');
			return;
		}
	
		this._postForm();
	};
	
	ContactFormController.prototype._postForm = function() {
		var valuesObj = this._getUserInputValues();
		if (!valuesObj || valuesObj.__validationFailed) {
			this._elem.reportValidity();
			return;
		}
	
		var formData = this._createFormData(valuesObj);
	
		this._waitingForResponse = true;
		this._elem.classList.add('waiting_for_response');
	
		_ajax.ajax(this._method, this._actionUrl, this._onReqEnd.bind(this), formData);
	};
	
	ContactFormController.prototype._onReqEnd = function(xhr) {
		if (!this._elem) return;
	
		this._waitingForResponse = false;
		this._elem.classList.remove('waiting_for_response');
	
		var res;
	
		try {
			res = JSON.parse(xhr.responseText);
		} catch(e) {
			res = false;
		}
	
		if (xhr.status === 200) {
			// this._sendCustomEvent(this._elem, 'formSubmitted', { bubbles: true });
			// console.log({
			// 	e: this.NAME + ': _onReqEnd success',
			// 	status: xhr.status,
			// 	xhr: xhr,
			// 	res: xhr.responseText,
			// 	res1: JSON.parse(xhr.responseText)
			// });
	
			if (res.success) {
				if (this._callback) {
					this._callback(this);
				}
			} else {
				// this._elem.classList.remove('waiting_for_response');
			}
		} else {
	//		new ModalWindow({
	//			modalClass: 'error_notification',
	//			modalInnerHTML: '<p>Произошла непредвиденная ошибка!</p>' +
	//			'<p>Пожалуйста, повторите попытку позже.</p>'
	//		});
	
			// console.log({
			// 	e: this.NAME + ': _onReqEnd error',
			// 	status: xhr.status,
			// 	xhr: xhr,
			// 	res: xhr.responseText,
			// 	res1: JSON.parse(xhr.responseText)
			// });
	
		}
	};
	
	try {
		module.exports = ContactFormController;
	} catch (err) {
		console.warn(err);
	}


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var Helper = __webpack_require__(4);
	var CustomSelect = __webpack_require__(3);
	var CustomInputRange = __webpack_require__(16);
	var CustomUploadButton = __webpack_require__(17);
	
	function FormTemplate(options) {
		options.name = options.name || 'FormTemplate';
		Helper.call(this, options);
	
		this._elem = options.elem;
		this._actionUrl = options.actionUrl || "";
		this._method = options.method || 'GET';
	
		this._onFocus = this._onFocus.bind(this);
		this._onInput = this._onInput.bind(this);
	
		this._initCustomElements();
	}
	
	FormTemplate.prototype = Object.create(Helper.prototype);
	FormTemplate.prototype.constructor = FormTemplate;
	
	FormTemplate.prototype.remove = function() {
		var i;
	
		if (this._customSelectArr && this._customSelectArr.length > 0) {
			for (i = 0; i < this._customSelectArr.length; i++) {
				this._customSelectArr[i].remove();
			}
		}
	
		if (this._customInputRangeArr && this._customInputRangeArr.length > 0) {
			for (i = 0; i < this._customInputRangeArr.length; i++) {
				this._customInputRangeArr[i].remove();
			}
		}
	
		if (this._customUploadButtonArr && this._customUploadButtonArr.length > 0) {
			for (i = 0; i < this._customUploadButtonArr.length; i++) {
				this._customUploadButtonArr[i].remove();
			}
		}
	
		Helper.prototype.remove.apply(this, arguments);
	};
	
	FormTemplate.prototype._initCustomElements = function() {
		var i;
	
		var customSelectElemArr = this._elem.querySelectorAll('.customselect');
	
		if (customSelectElemArr.length > 0) {
			this._customSelectArr = [];
	
			for (i = 0; i < customSelectElemArr.length; i++) {
				this._customSelectArr[i] = new CustomSelect({
					elem: customSelectElemArr[i]
				});
			}
		}
	
		var customInputRangeElemArr = this._elem.querySelectorAll('.custom_input_range');
	
		if (customInputRangeElemArr.length > 0) {
			this._customInputRangeArr = [];
	
			for (i = 0; i < customInputRangeElemArr.length; i++) {
				this._customInputRangeArr[i] = new CustomInputRange({
					elem: customInputRangeElemArr[i],
					max: customInputRangeElemArr[i].getAttribute('data-max-value'),
					min: customInputRangeElemArr[i].getAttribute('data-min-value'),
					initialValue: customInputRangeElemArr[i].getAttribute('data-default-value')
				});
			}
		}
	
		var customUploadButtonElemArr = this._elem.querySelectorAll('.uploadbutton');
	
		if (customUploadButtonElemArr.length > 0) {
			this._customUploadButtonArr = [];
	
			for (i = 0; i < customUploadButtonElemArr.length; i++) {
				this._customUploadButtonArr[i] = new CustomUploadButton({
					elem: customUploadButtonElemArr[i]
				});
			}
		}
	};
	
	FormTemplate.prototype._getUserInputValues = function() {
		var inputsArr = this._elem.querySelectorAll('[data-component="form-input"]');
		if (inputsArr.length === 0) return false;
	
		var res = {},
			escape = document.createElement('textarea'),
			input,
			name,
			value,
			j;
	
		function escapeHTML(html) {
			escape.textContent = html;
			return escape.innerHTML;
		}
	
		for (var i = 0; i < inputsArr.length; i++) {
			input = inputsArr[i];
	
			if (input.tagName === 'INPUT' || input.tagName === 'TEXTAREA' || input.tagName === 'SELECT') {
				name = input.name;
	
				if (input.matches('input[type="file"]')) {
					if (input.files.length === 0) continue;
	
					value = [];
					for (j = 0; j < input.files.length; j++) {
						value.push(input.files[j]);
					}
	
				} else {
					value = escapeHTML(input.value);
	
				}
	
			} else if (input.classList.contains('customselect')) {
				name =  input.getAttribute('data-name');
				value = escapeHTML(input.dataset.value);
	
			} else if (input.classList.contains('custom_input_range')) {
				name =  input.getAttribute('data-name');
				value = escapeHTML(input.dataset.value);
	
			} else if (input.classList.contains('uploadbutton')) {
				name = input.getAttribute('data-name');
				value = '';
	
				var inputFile = input.querySelector('input[type="file"]');
	
				if (inputFile.files.length > 0) {
					value = [];
					for (j = 0; j < inputFile.files.length; j++) {
						value.push(inputFile.files[j]);
					}
				}
			}
	
			if (!this._validateField(input, value)) {
				res.__validationFailed = true;
			}
	
			j = 1;
			while (res.hasOwnProperty(name)) {
				name += '' + j;
				j++;
			}
	
			res[name] = value;
		}
	
		return res;
	};
	
	FormTemplate.prototype._validateField = function(input, value) {
		var valid = true;
	
		if (input.classList.contains('required') && value === '') {
			this._markAsError(input);
			valid = false;
		} else if (value !== '' && input.matches('input[type="email"]') && !this._isValidEmailAddress(value)) {
			this._markAsError(input, 'Введите валидный электронный адрес.');
			valid = false;
		}
	
		return valid;
	};
	
	FormTemplate.prototype._markAsError = function(input, message) {
		message = message ? message : 'Это обязательное поле.';
		input.classList.add('error');
		input.setCustomValidity(message);
	
		this._addListener(input, 'focus', this._onFocus, true);
		this._addListener(input, 'change', this._onInput);
		this._addListener(input, 'input', this._onInput);
	};
	
	FormTemplate.prototype._onFocus = function(e) {
		var currentTarget = e.currentTarget;
		this._removeListener(currentTarget, 'focus', this._onFocus, true);
		currentTarget.classList.remove('error');
	};
	
	FormTemplate.prototype._onInput = function(e) {
		var currentTarget = e.currentTarget;
		currentTarget.setCustomValidity('');
	
		this._removeListener(currentTarget, 'change', this._onInput);
		this._removeListener(currentTarget, 'input', this._onInput);
	};
	
	FormTemplate.prototype._isValidEmailAddress = function(emailAddress) {
		var pattern = new RegExp(/^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i);
		return pattern.test(emailAddress);
	};
	
	FormTemplate.prototype._createFormData = function(valuesObj) {
		var dataObjArr = this._getDataObjArr(valuesObj);
		if (!dataObjArr) return;
	
		var formData = new FormData();
	
		for (var i = 0; i < dataObjArr.length; i++) {
			formData.append(dataObjArr[i].name, dataObjArr[i].value);
		}
	
		return formData;
	};
	
	FormTemplate.prototype._getDataObjArr = function(valuesObj) {
		var dataObjArr = [];
	
		for (var key in valuesObj) {
	
			if (Array.isArray(valuesObj[key])) {
				for (var i = 0; i < valuesObj[key].length; i++) {
					dataObjArr.push({
						name: key,
						value: valuesObj[key][i]
					});
				}
	
			} else {
				dataObjArr.push({
					name: key,
					value: valuesObj[key]
				});
	
			}
		}
	
		return dataObjArr;
	};
	
	module.exports = FormTemplate;


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	try {
		var Helper = __webpack_require__(4);
	} catch (err) {
		console.warn(err);
	}
	
	function CustomInputRange(options) {
		options.name = options.name || 'CustomInputRange';
		Helper.call(this, options);
	
		this._elem = options.elem;
	
		this._rulerElem = this._elem.querySelector('.ruler');
		this._thumbElem = this._elem.querySelector('.thumb');
	
		this._min = isNaN(parseInt(options.min)) ? 0 : parseInt(options.min);
		this._max = isNaN(parseInt(options.max)) ? 10 : parseInt(options.max);
		this._percentPerValue = 100 / (this._max - this._min);
	
		var initialValue = isNaN(parseInt(options.initialValue)) ? this._min : parseInt(options.initialValue);
		this.setValue(initialValue);
	
		this._onMouseDown = this._onMouseDown.bind(this);
		this._onDocumentMouseMove = this._onDocumentMouseMove.bind(this);
		this._onDocumentMouseUp = this._onDocumentMouseUp.bind(this);
	
		this._revealPublicMethods();
	
		this._addListener(this._elem, 'dragstart', function(e) {e.preventDefault();});
		this._addListener(this._elem, 'mousedown', this._onMouseDown);
		this._addListener(this._elem, 'touchstart', this._onMouseDown);
	}
	
	CustomInputRange.prototype = Object.create(Helper.prototype);
	CustomInputRange.prototype.constructor = CustomInputRange;
	
	CustomInputRange.prototype._onMouseDown = function(e) {
		if (e.target.closest('.thumb')) {
			var clientX = (e.clientX === undefined) ? e.changedTouches[0].clientX : e.clientX;
			var clientY = (e.clientY === undefined) ? e.changedTouches[0].clientY : e.clientY;
	
			e.preventDefault();
			this._startDrag(clientX, clientY);
		}
	};
	
	CustomInputRange.prototype._startDrag = function(startClientX, startClientY) {
		this._thumbCoords = this._thumbElem.getBoundingClientRect();
		this._shiftX = startClientX - this._thumbCoords.left;
		this._shiftY = startClientY - this._thumbCoords.top;
	
		this._rullerCoords = this._rulerElem.getBoundingClientRect();
	
		this._onDocumentMouseMove({clientX: startClientX});
		this._addListener(document, 'mousemove', this._onDocumentMouseMove);
		this._addListener(document, 'touchmove', this._onDocumentMouseMove);
		this._addListener(document, 'mouseup', this._onDocumentMouseUp);
		this._addListener(document, 'touchend', this._onDocumentMouseUp);
	};
	
	CustomInputRange.prototype._onDocumentMouseMove = function(e) {
		var clientX = (e.clientX === undefined) ? e.changedTouches[0].clientX : e.clientX;
		this._moveTo(clientX);
	};
	
	CustomInputRange.prototype._onDocumentMouseUp = function(e) {
		this._endDrag();
	};
	
	CustomInputRange.prototype._moveTo = function(clientX) {
		if (!clientX) return;
		// вычесть координату родителя, т.к. position: relative
		var newLeft = clientX - this._shiftX - this._rullerCoords.left;
	
		// курсор ушёл вне слайдера
		if (newLeft < 0) {
			newLeft = 0;
		}
		var rightEdge = this._rulerElem.clientWidth;
		if (newLeft > rightEdge) {
			newLeft = rightEdge;
		}
	
		this._pixelLeft = newLeft;
		this._thumbElem.style.left = newLeft + 'px';
	
		var newValue = this._positionToValue(newLeft);
		if (newValue !== this._value) {
			this._value = newValue;
			this._elem.setAttribute('data-value', this._value);
	
			this._sendCustomEvent(this._elem, 'custominputrangeslide', {
				bubbles: true,
				detail: {
					value: this._value
				}
			});
		}
	};
	
	CustomInputRange.prototype._valueToPosition = function(value) {
		return this._percentPerValue * (value - this._min);
	};
	
	CustomInputRange.prototype._positionToValue = function(left) {
		var pixelPerValue = this._rulerElem.clientWidth / (this._max - this._min);
		return Math.round(left / pixelPerValue) + this._min;
	};
	
	CustomInputRange.prototype._pixelsToPercents = function(left) {
		return left * (100 / this._rulerElem.clientWidth);
	};
	
	CustomInputRange.prototype._endDrag = function() {
		this._removeListener(document, 'mousemove', this._onDocumentMouseMove);
		this._removeListener(document, 'touchmove', this._onDocumentMouseMove);
		this._removeListener(document, 'mouseup', this._onDocumentMouseUp);
		this._removeListener(document, 'touchend', this._onDocumentMouseUp);
	
		this._thumbElem.style.left = this._pixelsToPercents(this._pixelLeft) + '%';
	
		this._afterValueIsSet();
	};
	
	CustomInputRange.prototype._afterValueIsSet = function() {
		this._sendCustomEvent(this._elem, 'custominputrangechange', {
			bubbles: true,
			detail: {
				value: this._value
			}
		});
	};
	
	CustomInputRange.prototype.setValue = function(value) {
		value = parseInt(value);
	
		if (typeof value !== 'number') return;
	
		if (value > this._max) {
			value = this._max;
		} else if (value < this._min) {
			value = this._min;
		}
	
		this._value = value;
		this._elem.setAttribute('data-value', this._value);
		this._thumbElem.style.left = this._valueToPosition(value) + '%';
		this._pixelLeft = parseInt(getComputedStyle(this._thumbElem).left);
	
		this._afterValueIsSet();
	};
	
	CustomInputRange.prototype.getElem = function() {
		return this._elem;
	};
	
	CustomInputRange.prototype._revealPublicMethods = function() {
		this._elem.setValue = this.setValue.bind(this);
	};
	
	try {
		module.exports = CustomInputRange;
	} catch (err) {
		console.warn(err);
	}


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var Helper = __webpack_require__(4);
	
	function CustomUploadButton(options) {
		options.name = options.name || 'CustomUploadButton';
		Helper.call(this, options);
	
		this._elem = options.elem;
	
		this._visibleInput = this._elem.querySelector('.input');
		this._hiddenInput = this._elem.querySelector('input[type="file"]');
	
		this._defaultValue = this._visibleInput.textContent;
		this._hiddenInput.value = '';
	
		this._listenerArr = [];
	
		this._onChange = this._onChange.bind(this);
	
		this._addListener(this._elem, 'change', this._onChange);
	}
	
	CustomUploadButton.prototype = Object.create(Helper.prototype);
	CustomUploadButton.prototype.constructor = CustomUploadButton;
	
	CustomUploadButton.prototype._onChange = function(e) {
		var target = e.target;
	
		if (target !== this._hiddenInput) return;
	
		var fileName;
	
		if (this._hiddenInput.value === '') {
			// fileName = 'Attach file';
			fileName = this._defaultValue;
		} else {
			var valArr = this._hiddenInput.value.split('\\');
			fileName = valArr[valArr.length - 1];
		}
		this._visibleInput.innerHTML = fileName;
	};
	
	CustomUploadButton.prototype.resetToDefault = function() {
		this._hiddenInput.value = '';
		this._visibleInput.textContent = this._defaultValue;
	};
	
	CustomUploadButton.prototype.getElem = function() {
		return this._elem;
	};
	
	module.exports = CustomUploadButton;


/***/ }),
/* 18 */
/***/ (function(module, exports) {

	"use strict";
	
	var _ajax = {
	
		ajax: function(method, url, callback, data) {
	
			var xhr = new XMLHttpRequest();
	
			xhr.open(method, url, true);
			xhr._url = url;
	
			xhr.addEventListener('readystatechange', function onReadyStateChange() {
				if (this.readyState != 4) return;
	
				xhr.removeEventListener('readystatechange', onReadyStateChange);
				callback(this);
			});
	
			xhr.send(data);
		}
	
	};
	
	try {
		module.exports = _ajax;
	} catch (err) {
		console.warn(err);
	}


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// build.min.js